/* global System */
// register component(s) with react habitat

export default {
  JobsTable: () => System.import('./index'),
}
